import actionTypes from './types';
import get from 'lodash/get';

const initialState = {
  vehiclesData: {
    list: [],
    pageNo: 0,
    pageSize: 10,
    totalCount: 0,
    totalPages: 0,
  },
  isFetching: false,
  filtersData: {},
  itineraryData: {},
  pathDetails: {},
  currentLocation: {},
};

const vehicles = (state: any = initialState, action: { type: string; payload: any }) => {
  switch (action.type) {
    case actionTypes.FETCH_CONSIGNER_VEHCILES_START: {
      return {
        ...state,
        isFetching: true,
      };
    }

    case actionTypes.FETCH_CONSIGNER_VEHCILES_SUCCESS: {
      return {
        ...state,
        vehiclesData: {
          list: state.vehiclesData.list.concat(get(action, 'payload.list', [])),
          pageNo: get(action, 'payload.pageNo', 0),
          pageSize: get(action, 'payload.pageSize', 10),
          totalCount: get(action, 'payload.totalCount', 0),
          totalPages: get(action, 'payload.totalPages', 0),
        },
        isFetching: false,
      };
    }

    case actionTypes.RESET_CONSIGNER_VEHCILES: {
      return {
        ...state,
        vehiclesData: {
          list: [],
          pageNo: 0,
          pageSize: 10,
          totalCount: 0,
          totalPages: 0,
        },
      };
    }

    case actionTypes.FETCH_FILTERS_START: {
      return {
        ...state,
        filtersData: {},
      };
    }

    case actionTypes.FETCH_FILTERS_SUCCESS: {
      return {
        ...state,
        filtersData: action.payload,
      };
    }

    case actionTypes.FETCH_ITINERARY_DATA_START: {
      return {
        ...state,
        itineraryData: {},
      };
    }

    case actionTypes.FETCH_ITINERARY_DATA_SUCCESS: {
      return {
        ...state,
        itineraryData: action.payload,
      };
    }

    case actionTypes.FETCH_PATH_DETAILS_START: {
      return {
        ...state,
        pathDetails: {},
      };
    }

    case actionTypes.FETCH_PATH_DETAILS_SUCCESS: {
      return {
        ...state,
        pathDetails: action.payload,
      };
    }

    case actionTypes.FETCH_CURRENT_LOCATION_SUCCESS: {
      return {
        ...state,
        currentLocation: action.payload,
      };
    }

    default:
      return state;
  }
};

export default vehicles;
